export default __webpack_public_path__ + "static/media/formulario-navbar-icon.6682b91a.svg";